import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative border-t border-[#27272a] bg-[#050505] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-display text-4xl mb-4">
              <span className="bttf-text">EXTREME</span>{" "}
              <span className="text-white">OFFSET RIMS</span>
            </div>
            <p className="text-zinc-400 max-w-sm text-sm leading-relaxed">
              Aftermarket rims, tires, and suspension for trucks that refuse to
              blend in. A demo storefront built for the builders.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#00f0ff] mb-4">Shop</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/category/rims" className="hover:text-white">Rims</Link></li>
              <li><Link to="/category/tires" className="hover:text-white">Tires</Link></li>
              <li><Link to="/category/suspension" className="hover:text-white">Suspension</Link></li>
              <li><Link to="/brands" className="hover:text-white">Brand Directory</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#00f0ff] mb-4">Tools</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/tools" className="hover:text-white">Offset Calculator</Link></li>
              <li><Link to="/tools" className="hover:text-white">Tire Size Compare</Link></li>
              <li><Link to="/policies" className="hover:text-white">Shipping &amp; Returns</Link></li>
            </ul>
            <div className="mt-6 text-xs text-zinc-400 not-italic leading-relaxed">
              <div className="text-zinc-200 font-semibold">Extreme Offset Rims LLC</div>
              14740 Heritage Crest Way<br />Bluffdale, UT 84045<br />
              <a href="tel:+13852266398" className="hover:text-white">(385) 226-6398</a><br />
              <a href="mailto:extremeoffsetrims@gmail.com" className="hover:text-white">extremeoffsetrims@gmail.com</a>
            </div>
          </div>
        </div>
      </div>
      <div className="whitespace-nowrap overflow-hidden py-6 border-t border-[#27272a]">
        <div className="font-display text-6xl md:text-8xl text-stroke leading-none">
          EXTREME OFFSET RIMS • UNCOMPROMISED PERFORMANCE • EXTREME OFFSET RIMS • UNCOMPROMISED PERFORMANCE •
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-zinc-500 flex flex-col md:flex-row justify-between gap-2">
        <span>© 2026 Extreme Offset Rims LLC. All rights reserved.</span>
        <span><Link to="/policies" className="hover:text-white">Shipping · Returns · Warranty · Terms</Link></span>
      </div>
    </footer>
  );
}
